import React, { useState, useEffect, useRef } from 'react';
import { Row, Col } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import CsLineIcons from 'cs-line-icons/CsLineIcons';
// Utils
import { handlerErrors } from 'utils/handleErrors';
// components
import ConnectionError from 'components/emptyStates/ConnectionError';
import EditBillingUserModal from 'components/modals/EditBillingUserModal';
import ClipLoader from 'react-spinners/ClipLoader';
import HtmlHead from '../../../components/html-head/HtmlHead';
import LoadingCar from '../../../components/loading/LoadingCar';
import ExternalNotifications from './components/ExternalNotifications';
import InternalNotifications from './components/InternalNotifications';
// API services
import { getProfile } from '../../../api/Api-user';
import { useHandleResponse } from '../../../hooks/useHandleResponse';

const Notifications = () => {
  const title = 'Notificaciones';
  const description = 'Notificaciones de Rastreo Plataforma Autopaquete';
  // - Use references to do scroll Up
  const startRef = useRef(null);
  const history = useHistory();
  const { handleResponse } = useHandleResponse();
  const [activeTab, setActiveTab] = useState('Internal'); // 'Internal' o 'External'
  const [isLoadingStart, setIsLoadingStart] = useState(true);
  const [configData, setConfigData] = useState(true);
  const [trigger, setTrigger] = useState(false);

  const [configCard, setConfigCard] = useState(null);
  function submenuActive(e) {
    const submenuBtns = document.querySelectorAll('ul.nav-pills li button');
    const currentBtn = e.currentTarget.name;
    submenuBtns.forEach((btn) => {
      if (currentBtn === btn.name) {
        btn.classList.add('active');
      } else {
        btn.classList.remove('active');
      }
    });
  }

  const handlerGetProfile = async () => {
    setIsLoadingStart(true);

    try {
      const response = await getProfile();
      // console.log('datos de perfirl:', response);
      if (response.user_profile !== undefined) {
        setIsLoadingStart(false);
        setConfigData(response);
        //  setConfigCard(<InternalNotifications configData={response} setTrigger={setTrigger} key={trigger} />);
        // Renderiza según la pestaña activa
        if (activeTab === 'External') {
          setConfigCard(<ExternalNotifications configData={response} setTrigger={setTrigger} key={trigger} />);
        } else {
          setConfigCard(<InternalNotifications configData={response} setTrigger={setTrigger} key={trigger} />);
        }
      }
      if (startRef.current && startRef.current.scrollIntoView) {
        startRef.current.scrollIntoView({ behavior: 'smooth' });
      }
    } catch (error) {
      handlerErrors(error);
    }
  };
  const resetInfo = (e) => {
    const type = e.target.name;
    submenuActive(e);
    setActiveTab(type); // guardar la pestaña activa
    // switch (type) {
    //   case 'External':
    //     setConfigCard(<ExternalNotifications configData={configData} setTrigger={setTrigger} />);
    //     break;
    //   case 'Internal':
    //     setConfigCard(<InternalNotifications configData={configData} setTrigger={setTrigger} />);
    //     break;
    //   default:
    //     setConfigCard(<InternalNotifications configData={configData} setTrigger={setTrigger} />);
    // }
  };
  useEffect(() => {
    handlerGetProfile();
  }, [trigger, activeTab]);
  return (
    <>
      {isLoadingStart && <LoadingCar />}
      <div id="pageContainer" ref={startRef}>
        <HtmlHead title={title} description={description} />
        <Row className="g-0 mb-3">
          {/* Title Start col-auto */}
          <Col xs="auto" className="col-auto mb-sm-0 me-auto">
            <div className="muted-link pb-1 d-inline-block hidden breadcrumb-back cursor-pointer" onClick={() => history.goBack()}>
              <CsLineIcons icon="chevron-left" size="13" />
              <span className="align-middle text-small ms-1">Atrás</span>
            </div>
            <h1 className="mb-0 pb-0 display-4" id="title">
              {title}
            </h1>
          </Col>
          {/* Title End */}
        </Row>
        {/* Submenu horizontal */}
        <Row className="g-0 mb-5 bg-infox">
          <ul className="nav nav-pills">
            <li className="nav-item">
              <button type="button" className="nav-link active" name="Internal" onClick={(event) => resetInfo(event)}>
                Internas
              </button>
            </li>
            <li className="nav-item">
              <button type="button" className="nav-link" name="External" onClick={(event) => resetInfo(event)}>
                Externas
              </button>
            </li>
          </ul>
        </Row>
        <div className="bg-successx">{configCard}</div>
      </div>
    </>
  );
};

export default Notifications;
